module.exports = __webpack_public_path__ + "assets/244774__door15studio__spin-tick.8a3ad91c7e2c13ac226f57a261214147.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/244774__door15studio__spin-tick.mp3
// module id = 111
// module chunks = 0